import React from "react";

function VideoIcon({width = "20px", height = "20px", color = "#7030A0"}) {
  return (
    <svg
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path d="M21 7L15 12L21 17V7Z" />
        <path d="M13 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H13C14.1046 19 15 18.1046 15 17V7C15 5.89543 14.1046 5 13 5Z" />
      </g>
    </svg>
  );
}

export default VideoIcon;
